
import { React, useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { PieChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { getDate, getTime } from "components/common/dateTime";
import { useWindowSize } from "services/resizeservice";

function StateTransitionComponent(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    PieChart,
    CanvasRenderer,
  ]);

  props.data.map(function (obj) {});

  // var xAxisData = [];
  var yAxisCharging = [];
  var yAxisonDuty = [];
  var yAxisidle = [];

  if (props.data != undefined) {
    yAxisCharging = [];
    yAxisonDuty = [];
    yAxisidle = [];
    props.data.map(function (obj) {
      if (obj.charging == null) {
        obj.charging = 0;
        // yAxisCharging.push(obj.charging);
        yAxisCharging.push({ value: obj.charging, name: "Charging" });
      } else {
        // yAxisCharging.push(obj.charging);
        yAxisCharging.push({ value: obj.charging, name: "Charging" });
      }

      if (obj.onDuty == null) {
        obj.onDuty = 0;
        yAxisonDuty.push({ value: obj.onDuty, name: "on Duty" });
      } else {
        yAxisonDuty.push({ value: obj.onDuty, name: "on Duty" });
      }

      if (obj.idle == null) {
        obj.idle = 0;
        yAxisidle.push({ value: obj.idle, name: "Idle" });
      } else {
        yAxisidle.push({ value: obj.idle, name: "Idle" });
      }

      if (parseInt(yAxisCharging[0].value) == 0) {
        yAxisCharging.push({
          value: 100 - parseInt(yAxisCharging[0].value),
          name: "other",
        });
      } else {
        yAxisCharging.push({
          value: 100 - parseInt(yAxisCharging[0].value),
          name: "Idle\n+\nOn Duty",
        });
      }
      if (parseInt(yAxisonDuty[0].value) == 0) {
        yAxisonDuty.push({
          value: 100 - parseInt(yAxisonDuty[0].value),
          name: "Other",
        });
      } else {
        yAxisonDuty.push({
          value: 100 - parseInt(yAxisonDuty[0].value),
          name: "Charging\n+\nIdle",
        });
      }

      if (parseInt(yAxisidle[0].value) == 0) {
        yAxisidle.push({
          value: 100 - parseInt(yAxisidle[0].value),
          name: "Other",
        });
      } else {
        yAxisidle.push({
          value: 100 - parseInt(yAxisidle[0].value),
          name: "Charging\n+\nOn Duty",
        });
      }
      // yAxisidle.push(100 - yAxisidle[4]);
    });
  }

  const options = () => ({
    title: {
      text: "",
      left: "center",
      top: "45%",
      textStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: 22,
        color: "#383873",
      },
    },
    tooltip: {
      trigger: "item",
      position: 4,
    },
    legend: {
      data:["Charging", "On Duty", "Idle"],
      top: "1%",
      icon: "circle",
      left: "8px",
      top: "12px",
      bottom: "12px",
      itemWidth: 12,
      itemGap: 12,
      textStyle: {
        fontSize: "11",
        fontFamily: "JioType",
        fontStyle: "normal",
        color: "#C1C1C1",
      },
    },
    series: [
      {
        type: "pie",
        color: ["#FCC644", "#ced4da"],
        radius: ["55%", "60%"],
        avoidLabelOverlap: true,
        label: {
          show: false,
          position: "center",
        },
        name: "Charging",
        emphasis: {
          label: {
            show: true,
            fontSize: "0.9em",
            fontWeight: "bold",
          },
        },
        data: yAxisCharging,
      },
      {
        type: "pie",
        color: ["#E3324C", "#ced4da"],
        radius: ["45%", "50%"],
        label: {
          show: false,
          position: "center",
        },
        name: "On Duty",
        emphasis: {
          label: {
            show: true,
            fontSize: "0.9em",
            fontWeight: "bold",
          },
        },
        data: yAxisonDuty,
      },
      {
        type: "pie",
        color: ["#7734E1", "#ced4da", "#ced4da"],
        radius: ["35%", "40%"],
        label: {
          show: false,
          position: "center",
        },
        name: "Idle",
        emphasis: {
          label: {
            show: true,
            fontSize: "0.9em",
            fontWeight: "bold",
          },
        },
        data: yAxisidle,
      },
    ],
  });
  return (
    <ReactEcharts
      echarts={echarts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
      opts={{ renderer: "svg" }}
      option={options()}
    />
  );
}
export default StateTransitionComponent;
